export default __webpack_public_path__ + "static/media/kadra_dawid.07b47a13.jpeg";